import { CommandRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * commandOnUpdateData - Function that updates on database an personalized protocol command by id  
 * /commands/{id}  
 * method PUT 
 * @async-function
 */
const commandOnUpdateData = async (token: string, model: CommandRequestType, id: number) => {
    const response = await api.put(
        `/commands/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default commandOnUpdateData;